module.exports = __webpack_public_path__ + "img/sample-electromechanicalEngineer.70718297.webp";